/** Format seconds as HH:MM:SS (matches Ai-Tempo SecToHMS). */
export function secToHMS(totalSeconds: number): string {
  const s = Math.max(0, Math.round(Number(totalSeconds) || 0));
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const sec = s % 60;
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${pad(h)}:${pad(m)}:${pad(sec)}`;
}

/** Compact zone time — hide hours when under 1h. */
export function formatZoneTime(seconds: number): string {
  if (!seconds || seconds <= 0) return '00:00';
  const formatted = secToHMS(seconds);
  return formatted.startsWith('00:') ? formatted.slice(3) : formatted;
}
